function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    var self = this;

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('change', function () {
      var input = this;
      var max = input.max || false;
      if (max) {
        max = parseInt(max);
        if (input.value > max) {
          self.setAttribute('data-errorinfo', 'Maximum is ' + max);
          self.classList.add('errorShow');
          input.value = max;
          setTimeout(function () {
            self.classList.remove('errorShow');
          }, 3000);
        } else {
          self.classList.remove('errorShow');
        }
      }
    });

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

window.giftCardMixMessage = 'Gift cards and non-gift-card products cannot be added together.';

function getGiftCardCartState(items) {
  return (items || []).reduce(function (state, item) {
    if (item.giftCard) {
      state.hasGiftCards = true;
    } else {
      state.hasNonGiftCards = true;
    }
    return state;
  }, { hasGiftCards: false, hasNonGiftCards: false });
}

function showGiftCardMixError(element) {
  var existingError = document.getElementById('gift-card-mix-error');
  if (existingError) existingError.remove();

  var error = document.createElement('div');
  error.id = 'gift-card-mix-error';
  error.className = 'alert alert--error mb-20';
  error.setAttribute('role', 'alert');
  error.textContent = window.giftCardMixMessage;

  var cartErrors = document.getElementById('cart-errors');
  if (cartErrors) {
    cartErrors.appendChild(error);
  } else if (element && element.parentNode) {
    element.parentNode.insertBefore(error, element);
  }

  if (element) {
    element.removeAttribute('aria-disabled');
    element.classList.remove('loading');
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

class ModalClearCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  clearCart() {
    fetch(`${routes.cart_clear_url}`, {})
      .then(() => {
        window.location.reload();
      }).catch((error) => {
        console.error('Error:', error)
      });
  }
}

customElements.define('modal-clear-cart', ModalClearCart);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);



class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

/* Swiper Sliders */
function lbAddSwiper(el) {
  var swiperScript = document.getElementById(window.themeAssets.swiperJsId);
  if (!swiperScript || typeof Swiper == 'undefined') {
    var script = document.createElement('script');
    script.setAttribute('src', window.themeAssets.swiperJs);
    script.setAttribute('id', window.themeAssets.swiperJsId);
    document.head.appendChild(script);
    var styles = document.createElement('link');
    styles.setAttribute('href', window.themeAssets.swiperCss);
    styles.setAttribute('rel', 'stylesheet');
    styles.setAttribute('id', 'swiper-css');
    document.head.appendChild(styles);
  }
  var timeout = setInterval(function () {
    if (typeof Swiper != 'undefined') {
      clearInterval(timeout);
      lbInitSwiper(el);
    }
  }, 100);
}

function lbInitSwiper(el) {
  var swiperID = el.dataset.swiperId;
  var options = window.swiperOptions[swiperID];
  var selector = '#' + el.id;
  var sliderType = el.dataset.sliderType || 'always';
  var swiper = null;
  if (sliderType == 'mobile') {
    if (window.matchMedia("(max-width: 749px)").matches) {
      swiper = new Swiper(selector, options);
    }
    window.addEventListener('resize', function () {
      if (window.matchMedia("(min-width: 750px)").matches && swiper !== null) {
        swiper.destroy();
        swiper = null;
      } else if (window.matchMedia("(max-width: 749px)").matches && swiper == null) {
        swiper = new Swiper(selector, options);
      }
    });
  } else {
    swiper = new Swiper(selector, options);
  }
  return swiper;
}

window.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('.swiper-slider');
  var swiperHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      swiperObserver.unobserve(el);
      lbAddSwiper(el);
    });
  }
  var swiperObserver = new IntersectionObserver(swiperHandler);
  swipers.forEach(function (el) {
    swiperObserver.observe(el);
  });

  if (Shopify.designMode) {
    window.addEventListener('shopify:section:select', function (e) {
      swipers.forEach(function (el) {
        lbAddSwiper(el);
      });
    });
  }

});

// collection/search add grid view
function toggleGridView(e) {
  e.preventDefault();

  var toggleListButtons = document.querySelectorAll('.toggle-view-button.list-view-select');
  Array.from(toggleListButtons, x => {
    x.classList.remove('active--view')
  })

  let allGrid = document.querySelectorAll('.list-view-grid');
  Array.from(allGrid, x => {
    x.classList.add('active--view')
  })

  var gridItems = document.querySelectorAll('#product-grid .grid__item');
  Array.from(gridItems, item => {
    if (item.classList.contains('product-card__list-view')) {
      item.classList.add('width--50', 'widescreen--25', 'large-up--33', 'product-card__grid-view');
      item.classList.remove('product-card__list-view', 'width--100');
    }
    var card = item.querySelector('.product-card');
    if (card.classList.contains('product-card__list-view')) {
      card.classList.remove('product-card__list-view');
    }
  })
  fetch("/cart.json", {
    method: "POST",
    body: JSON.stringify({ attributes: { list_view: false } }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  })
}

// collection/search add list view
function toggleListView(e) {
  e.preventDefault();
  var toggleGridButtons = document.querySelectorAll('.toggle-view-button.list-view-grid');
  Array.from(toggleGridButtons, x => {
    x.classList.remove('active--view')
  })

  let allList = document.querySelectorAll('.list-view-select');
  Array.from(allList, x => {
    x.classList.add('active--view')
  })

  var gridItems = document.querySelectorAll('#product-grid .grid__item');
  Array.from(gridItems, item => {
    if (item.classList.contains('large-up--33')) {
      item.classList.remove('width--50', 'widescreen--25', 'large-up--33', 'product-card__grid-view');
      item.classList.add('product-card__list-view', 'width--100');
    }
    var card = item.querySelector('.product-card');
    if (!card.classList.contains('product-card__list-view')) {
      card.classList.add('product-card__list-view');
    }
  })
  fetch("/cart.json", {
    method: "POST",
    body: JSON.stringify({ attributes: { list_view: true } }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  })
}

function toggleFilter() {
  document.querySelector('.facetsMainContainer').classList.add('open-mobile__facets');
}
function closeFilter() {
  document.querySelector('.facetsMainContainer').classList.remove('open-mobile__facets');
}

//add sort by option 
if (window.innerWidth <= 749) {
  var sortBy = document.getElementById('SortBy');
  if (sortBy != undefined) {
    var hasSelected = false
    Array.from(sortBy.querySelectorAll('option'), x => {
      if (x.selected == true && x.innerText != "Featured") {
        hasSelected = true;
      }
    })
    if (hasSelected === false) {
      var optionsInsert = document.createElement('option');
      optionsInsert.text = "Sort By";
      optionsInsert.classList.add('left');
      optionsInsert.setAttribute('selected', 'selected');
      optionsInsert.setAttribute('disabled', 'disabled');
      sortBy.prepend(optionsInsert);
    }
  }
}

const mobileApply = document.getElementById('applyMobileFacets');
if (mobileApply) {
  mobileApply.addEventListener('click', function () {
    var facetsForm = document.getElementById('FacetFiltersForm');
    var allCheckedInputs = facetsForm.querySelectorAll('input[type=checkbox]:checked');
    var length = parseInt(allCheckedInputs.length)
    if (length === 0) {
      alert('Please select a filter.')
    }
  });
}

//close announcement bar and check for session storage for continue to hide on mobile.
// added resize function for working when resizing the screen.
var lbAnnBar = document.getElementById('shopify-section-theme-announcement-bar');
if (lbAnnBar) {
  var lbHeader = document.getElementById('shopify-section-theme-header');
  var lbNavBarMobile = document.querySelector('.site-nav');

  //check load for hideAccBar
  if (!window.sessionStorage.getItem("hideAnBar")) {
    lbAnnBar.style.display = 'flex';
    lbHeader.classList.add('mobileHeaderMargin');
  }

  function hideAnnCheck() {
    lbAnnBar.style.display = "none";
    lbHeader.style.marginTop = '0px';
    lbNavBarMobile.style.top = '62px';
    lbABToggle();
    window.addEventListener("resize", function () {
      lbABToggle();
    })
  }

  function lbABToggle() {
    if (window.matchMedia("(min-width: 750px)").matches) {
      lbAnnBar.setAttribute('style', 'display: flex; margin-top: 0px;');
      lbHeader.style.marginTop = '52px';
      lbNavBarMobile.style.top = '101px';
    } else if (window.matchMedia("(max-width: 749px)").matches) {
      lbAnnBar.style.display = "none";
      lbHeader.style.marginTop = '0px';
      lbNavBarMobile.style.top = '62px';
    }
  }

  if (window.sessionStorage.getItem("hideAnBar")) {
    hideAnnCheck();
  }

  //close announcement bar function for button, to add resize listener.
  function closeAnnouncementBar() {
    window.sessionStorage.setItem('hideAnBar', 'true');
    hideAnnCheck();
  }
}

//survey modal
if (window.showSurvey) {
  fetch("?section_id=theme-modal-survey")
    .then(response => response.text())
    .then(data => {
      var html = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
      if (html !== '') {
        document.getElementById('MainContent').insertAdjacentHTML('beforebegin', data);
        var surveyModal = document.getElementById('inv-survey');
        surveyModal.classList.remove('hide');
        var surveyInputs = document.querySelectorAll('.inv-survey__input');
        var submitButton = document.querySelector('.inv-survey__submit-button');
        surveyInputs.forEach((x) => {
          x.addEventListener('input', function (evt) {
            var parent = this.closest('.input-wrapper');
            if (this.value == '') {
              parent.setAttribute('data-errorInfo', 'Enter Item Count');
              parent.classList.add('errorShow');
            } else if (parseInt(this.value) > parseInt((this.max ? this.max : 0))) {
              parent.setAttribute('data-errorInfo', 'Value must be less than or equal to ' + this.max);
              parent.classList.add('errorShow');
            } else {
              parent.classList.remove('errorShow');
            }
            let validInputs = Array.from(surveyInputs).filter(function (input) {
              return input.value !== '' && !input.closest('.input-wrapper').classList.contains('errorShow');
            });
            if (validInputs.length === surveyInputs.length) {
              submitButton.disabled = false;
            } else {
              submitButton.disabled = true;
            }
          });
        });
        submitButton.addEventListener("click", function () {
          this.disabled = true;
          var today = new Date();
          var submitDate = today.getFullYear() + "-" + (today.getMonth() + 1).toString().padStart(2, '0') + "-" + (today.getDate()).toString().padStart(2, '0');
          var items = [];
          surveyInputs.forEach((x) => {
            var item = x.dataset.item + ":" + x.value;
            items.push(item);
          });
          var metaData = {
            "customer[id]": window.customerID,
            "metafield[global.inventory_survey]": JSON.stringify(items),
            "metafield[global.inventory_survey_date]": submitDate
          };
          fetch("/a/custmeta", {
            method: "POST",
            body: new URLSearchParams(metaData).toString(),
            headers: { "Content-type": "application/x-www-form-urlencoded" }
          }).then((response) => response.json())
            .then((response) => {
              if (response.status !== 'ERROR') {
                document.getElementById('inv-survey-success').classList.remove('hide');
              }
              document.getElementById('inv-survey-table').classList.add('hide');
              setTimeout(function () {
                surveyModal.classList.add('hide');
              }, 3000);
            }).catch((error) => {
              console.error('Error:', error);
            });
        });
      }
    });
}

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.warning = document.getElementById('cart-warning');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.modal__close-button').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open(id) {
    if (id.indexOf('cart-warning') !== -1) {
      this.warning.setAttribute('aria-hidden', false);
      this.warning.focus();
      trapFocus(this.warning);
    } else {
      this.notification.setAttribute('aria-hidden', false);
      this.notification.focus();
      trapFocus(this.notification);
    }
    this.classList.remove('hide');
    document.body.addEventListener('click', this.onBodyClick);
    this.updateItemCaps()
  }

  close() {
    this.classList.add('hide');
    this.notification.setAttribute('aria-hidden', true);
    this.warning.setAttribute('aria-hidden', true);
    var loadingButton = document.querySelector('product-form button.loading');
    if (loadingButton) {
      loadingButton.classList.remove('loading');
      loadingButton.removeAttribute('aria-disabled');
      loadingButton.querySelector('.loading__spinner').classList.add('hidden');
    }
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.key) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        var sectionEl = document.getElementById(section.id);
        sectionEl.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (section.id == 'cart-notification-summary') {
          sectionEl.querySelector('.atc-cart__close').addEventListener('click', this.close.bind(this));
        }
      }));
      this.open('cart-notification');
    } else { // order form, go to cart
      window.location.href = routes.cart_url;
    }
  }

  renderWarning(html, id, form, formData, cartItems) {
    var warningContent = document.getElementById('cart-warning-content');
    var self = this;
    warningContent.innerHTML = this.getSectionInnerHTML(html, `[id="${id}"]`);
    let updateButton = warningContent.querySelector('.cart-warning__update');
    this.setSpinnerState(updateButton, false);
    updateButton.addEventListener('click', function (event) {

      self.setSpinnerState(event.currentTarget, true);

      if (id.indexOf('gift-card') !== -1 || id.indexOf('requires-approval') !== -1) { // Exclusive cart item
        fetch(`${routes.cart_clear_url}`, {
          method: "POST",
          headers: { "Content-type": "application/json", "Accept": "application/json" }
        }).then((response) => response.json())
          .then((response) => {
            form.addToCart(formData);
            self.close();
          });
      } else if (id.indexOf('presale') !== -1) { // Presale
        fetch(`${routes.cart_clear_url}`, {
          method: "POST",
          headers: { "Content-type": "application/json", "Accept": "application/json" }
        }).then((response) => response.json())
          .then((response) => {
            form.addToCart(formData);
            self.close();
          });
      } else { // Emergency
        var updateObj = { updates: {} };
        if (id == 'cart-warning-add-emergency') { // remove non-emergency items
          var nonEmergency = cartItems.filter(function (item) {
            return !item.emergency;
          })
          for (var i = 0; i < nonEmergency.length; i++) {
            updateObj.updates[nonEmergency[i].key] = 0;
          }
        } else { // remove emergency-only items
          var emergencyOnly = cartItems.filter(function (item) {
            return item.emergencyOnly;
          });
          for (var i = 0; i < emergencyOnly.length; i++) {
            updateObj.updates[emergencyOnly[i].key] = 0;
          }
        }
        fetch(`${routes.cart_update_url}`, {
          method: "POST",
          body: JSON.stringify(updateObj),
          headers: { "Content-type": "application/json", "Accept": "application/json" }
        }).then((response) => response.json())
          .then((response) => {
            form.addToCart(formData);
            self.close();
          });
      }
    });
    this.open(id);
  }

  renderBundlelWarning(html, id, element, cartItems) {
    var warningContent = document.getElementById('cart-warning-content');
    var self = this;
    var data_items = $.parseJSON($(element).attr('data-items'));
    warningContent.innerHTML = this.getSectionInnerHTML(html,`[id="${id}"]`);
    let updateButton = warningContent.querySelector('.cart-warning__update');
    this.setSpinnerState(updateButton, false);
    updateButton.addEventListener('click',function(event){

      self.setSpinnerState(event.currentTarget, true);

      if (id.indexOf('gift-card') !== -1 || id.indexOf('requiresApproval') !== -1) { // Exclusive cart item
        fetch(`${routes.cart_clear_url}`,{
          method: "POST",
          headers: {"Content-type": "application/json", "Accept": "application/json"}
        }).then((response) => response.json())
        .then((response) => {
          self.bundleAddToCart(data_items, element);
          self.close();
        });
      } else if (id.indexOf('presale') !== -1) { // Presale
        fetch(`${routes.cart_clear_url}`,{
          method: "POST",
          headers: {"Content-type": "application/json", "Accept": "application/json"}
        }).then((response) => response.json())
        .then((response) => {
          self.bundleAddToCart(data_items, element);
          self.close();
        });
      } else { // Emergency
        var updateObj = {updates:{}};
        if(id == 'cart-warning-add-emergency') { // remove non-emergency items
          var nonEmergency = cartItems.filter(function(item){
            return !item.emergency;
          })
          for(var i = 0; i < nonEmergency.length; i++){
            updateObj.updates[nonEmergency[i].key] = 0;
          }
        } else { // remove emergency-only items
          var emergencyOnly = cartItems.filter(function(item){
            return item.emergencyOnly;
          });
          for(var i = 0; i < emergencyOnly.length; i++){
            updateObj.updates[emergencyOnly[i].key] = 0;
          }
        }
        fetch(`${routes.cart_update_url}`,{
          method: "POST",
          body: JSON.stringify(updateObj),
          headers: {"Content-type": "application/json", "Accept": "application/json"}
        }).then((response) => response.json())
        .then((response) => {
          self.bundleAddToCart(data_items, element);
          self.close();
        });
      }
    });
    
    this.open(id);
  }

  setSpinnerState(button, loading = false) {
      if (loading) {
        button.classList.add('disabled');
        button.classList.add('loading');
        button.classList.remove('color--pink-1');
        button.querySelector('.loading__spinner').classList.remove('hidden');
        button.querySelector('.button__text').classList.add('hidden');
      } else {
        button.classList.remove('disabled');
        button.classList.remove('loading');
        button.classList.add('color--pink-1');
        button.querySelector('.loading__spinner').classList.add('hidden');
        button.querySelector('.button__text').classList.remove('hidden');
      }
  }

  bundleAddToCart(dataItems, element) {
    fetch(`${routes.cart_url}?view=rules`, {
      method: 'GET',
      headers: { 'Content-type': 'text/html; charset=UTF-8' }
    })
      .then((response) => response.json())
      .then(() => {
        var itemsToAdd = dataItems.map(function (item) {
          return {
            id: item.id,
            quantity: item.quantity,
            properties: item.properties || {}
          };
        });

        $.post('/cart/add.js', { items: itemsToAdd }, function () {
          setTimeout(function () {
            window.location.href = routes.cart_url;
          }, 750);
        }).fail(function () {
          if (element) {
            element.removeAttribute('aria-disabled');
            element.classList.remove('loading');
          }
        });
      })
      .catch(function () {
        if (element) {
          element.removeAttribute('aria-disabled');
          element.classList.remove('loading');
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-summary'
      },
      {
        id: 'cart-icon-count'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target == this || !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  updateItemCaps() {
    $.each(item_cap_items_object, function (key, value) {
      $("[item-cap-data-handle='" + key + "']").find('.current-item-cap').text(value);
      var allowed_qty = parseInt($("[item-cap-data-handle='" + key + "']").attr("item-cap-data-max")) - value;
      $("[item-cap-data-handle='" + key + "']").find('.quantity__input').attr("max", allowed_qty);
    });
  }
}

customElements.define('cart-notification', CartNotification);

if(!customElements.get('package-form')) {
  customElements.define('package-form', class PackageForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cartNotification = document.querySelector('#cart-notification-wrapper');
      this.submitButton = this.querySelector('');
    }
  })
}

/* Product Form */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.classList.contains('order-form')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('#cart-notification-wrapper');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      var previousGiftCardError = document.getElementById('gift-card-mix-error');
      if (previousGiftCardError) previousGiftCardError.remove();

      this.cartNotification.setActiveElement(document.activeElement);
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
      var formData = null;
      var isEmergency = false;
      var isEmergencyOnly = false;
      var isRequiresApprovalSupply = false;
      var isRequiresApprovalVisual = false;
      var isPresaleItem = false;
      var hasPendingGiftCards = false;
      var hasPendingNonGiftCards = false;

      if (!this.classList.contains('order-form')) { // normal product form
        this.handleErrorMessage();
        formData = new FormData(this.form);
        isEmergency = formData.get('emergency') || false;
        isEmergencyOnly = formData.get('emergency-only') || false;
        isRequiresApprovalSupply = formData.get('requires-approval-supply') || false;
        isRequiresApprovalVisual = formData.get('requires-approval-visual') || false;
        isPresaleItem = formData.get('presale') || false;
        hasPendingGiftCards = Boolean(formData.get('gift-card'));
        hasPendingNonGiftCards = !hasPendingGiftCards;
      } else { // order form
        var inputs = document.querySelectorAll('.order-form__qty .quantity__input');
        formData = { items: [] };
        var isEmergencyCount = 0;
        var nso = this.classList.contains('nso-form');

        inputs.forEach((input) => {
          var qty = parseInt(input.value);
          if (isNaN(qty) || qty <= 0) return;
          let item = {
            id: parseInt(input.dataset.id),
            quantity: parseInt(input.value),
            properties: {}
          }
            item.properties['_order_form'] = true;
          if (input?.dataset?.uom) {
            item.properties['_uom'] = input?.dataset?.uom;
          }
          if (input?.dataset?.msrp) {
            item.properties['_msrp'] = input.dataset.msrp;
          }
          if (input?.dataset?.store) {
            item.properties["_store_distro"] = input.dataset.store;
          }
          if (nso) {
            item.properties['_nso'] = nso;
          }

          formData.items.push(item);
          if (input.dataset.giftCard == 'true') {
            hasPendingGiftCards = true;
          } else {
            hasPendingNonGiftCards = true;
          }
          if (input.dataset.rule == 'emergency-only') {
            isEmergencyOnly = true;
          }
          if (input.dataset.rule == 'requires-approval-supply') {
            isRequiresApprovalSupply = true;
          }
          if (input.dataset.rule == 'requires-approval-visual') {
            isRequiresApprovalVisual = true;
          }
          if (input.dataset.rule == 'presale') {
            isPresaleItem = true;
          }
          if ((input.dataset.rule).indexOf('emergency') !== -1) {
            isEmergencyCount++;
          }
        });
        if (isEmergencyCount == inputs.length) {
          isEmergency = true;
        }
      }

      if (hasPendingGiftCards && hasPendingNonGiftCards) {
        this.handleGiftCardMixError();
        return;
      }

      fetch(`${routes.cart_url}?view=rules`, {
        method: "GET",
        headers: { "Content-type": "text/html; charset=UTF-8" }
      })
        .then((response) => response.text())
        .then((response) => {
          var cartItems = JSON.parse(response);
          var hasEmergencyOnly = false;
          var hasRequiresApprovalSupply = false;
          var existingRequiresApprovalSupplyIDs = [];
          var hasRequiresApprovalVisual = false;
          var existingRequiresApprovalVisualIDs = [];
          var hasPresaleItem = false;
          var numItems = cartItems.length;
          var numEmergency = 0;
          var numPresale = 0;
          var hasDraftOrder = false;
          var allowAdd = (numItems > 0) ? false : true;

          for (var i = 0; i < numItems; i++) {
            var item = cartItems[i];
            if (item.emergencyOnly) {
              hasEmergencyOnly = true;
            }
            if (item.emergency) {
              numEmergency++;
            }
            if (item.requiresApprovalSupply) {
              hasRequiresApprovalSupply = true;
              existingRequiresApprovalSupplyIDs.push(item.id);
            }
            if (item.requiresApprovalVisual) {
              hasRequiresApprovalVisual = true;
              existingRequiresApprovalVisualIDs.push(item.id);
            }
            if (item.presaleItem) {
              hasPresaleItem = true;
              numPresale++;
            }
          }
          
          var giftCardCartState = getGiftCardCartState(cartItems);
          if (hasPendingGiftCards && giftCardCartState.hasNonGiftCards) {
            this.getWarning('cart-warning-add-gift-card', formData, cartItems);
            return;
          }
          if (hasPendingNonGiftCards && giftCardCartState.hasGiftCards) {
            this.getWarning('cart-warning-add-non-gift-card', formData, cartItems);
            return;
          }

          if (numItems > 0) { // has items in the cart
            if (isRequiresApprovalSupply && !hasRequiresApprovalSupply) { // add Requires Approval Supply msg
              this.getWarning('cart-warning-add-requires-approval-supply', formData);
            } else if (isRequiresApprovalVisual && !hasRequiresApprovalVisual) { // add Requires Approval Visual msg
              this.getWarning('cart-warning-add-requires-approval-visual', formData);
            } else if (hasRequiresApprovalSupply && !isRequiresApprovalSupply) { // add non-Requires Approval Supply msg
              this.getWarning('cart-warning-add-non-requires-approval-supply', formData);
            } else if (hasRequiresApprovalVisual && !isRequiresApprovalVisual) { // add non-Requires Approval Visual msg
              this.getWarning('cart-warning-add-non-requires-approval-visual', formData);
            } else if (numPresale !== numItems && isPresaleItem) { // add Presale msg
              this.getWarning('cart-warning-add-presale', formData, cartItems);
            } else if (hasPresaleItem && !isPresaleItem) { // add non-Presale msg
              this.getWarning('cart-warning-add-non-presale', formData, cartItems);
            } else if (numEmergency !== numItems && isEmergencyOnly) { // add Emergency msg
              this.getWarning('cart-warning-add-emergency', formData, cartItems);
            } else if (hasEmergencyOnly && !isEmergency) { // add non-Emergency msg
              this.getWarning('cart-warning-add-non-emergency', formData, cartItems);
            } else {
              allowAdd = true;
            }
          } else {
            allowAdd = true;
          }
          if (allowAdd) {
            this.addToCart(formData);
          }
        })
        .catch((error) => {
          console.error(error);
          this.resetSubmitState();
        });
    }

    getWarning(id, formData, cartItems) {
      fetch("?sections=cart-notification-warning", {
        method: "GET",
        headers: { "Content-type": "text/html; charset=UTF-8" }
      })
        .then((response) => response.text())
        .then((response) => {
          var section = JSON.parse(response);
          var html = section["cart-notification-warning"];
          this.cartNotification.renderWarning(html, id, this, formData, cartItems);
        });
    }

    addToCart(formData) {
      const config = fetchConfig('javascript');
      if (formData.items) { // order form
        formData.sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        formData = JSON.stringify(formData);
      } else { // normal product form
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (this.classList.contains('order-form') && typeof orderFormSubmitError == 'function') {
              orderFormSubmitError(response.description);
            } else {
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }
          this.error = false;
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }

    handleGiftCardMixError() {
      if (this.classList.contains('order-form') && typeof orderFormSubmitError == 'function') {
        orderFormSubmitError(window.giftCardMixMessage);
      } else {
        this.handleErrorMessage(window.giftCardMixMessage);
        if (!this.errorMessageWrapper) showGiftCardMixError(this.submitButton);
      }
      this.resetSubmitState();
    }

    resetSubmitState() {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      var spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.pdp-form__error');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.pdp-form__error-msg');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

//initialize lanuage names
var langIMG = document.getElementById('language-selector__selected-image');
if (langIMG) {
  var langTitle = document.getElementById('selectedLanguageTitle');
  var langFrom = Weglot.options.language_from;
  var langName = Weglot.getLanguageName(langFrom);
  langTitle.textContent = Weglot.options.language_from;
  langIMG.setAttribute('alt', langName);
  //dynamically populate mobile language select
  function addLanguages() {
    var subLang = document.getElementById('subLanguageNavMobile');
    var htmlNeeded = "";
    var languageFrom = Weglot.options.language_from;
    var availableLanguages = Weglot.options.languages;
    if (availableLanguages) {
      availableLanguages.map(function (language) {
        var lang = language.language_to;
        htmlNeeded += `<li class="site-subnav__item">
          <a class="site-subnav__item-link mobile-language-link" href="http://change-language.weglot.com/${lang}">
            ${Weglot.getLanguageName(lang)}
          </a>
        </li>`
      });
    }
    var fromLanguageTemp = `<li class="site-subnav__item"><a class="site-subnav__item-link mobile-language-link" href="http://change-language.weglot.com/${languageFrom}">${Weglot.getLanguageName(languageFrom)}</li>`;
    subLang.innerHTML = fromLanguageTemp += htmlNeeded;
  }
  window.addEventListener('DOMContentLoaded', function () {
    addLanguages();
  });

  //onchange change selected option.
  Weglot.on("languageChanged", function (newLanguage) {
    var langName = Weglot.getLanguageName(newLanguage);
    if (newLanguage == 'en') {
      newLanguage = 'us'
    }
    langIMG.src = "https://cdn.weglot.com/flags/circle/" + newLanguage + ".svg"
    langIMG.setAttribute('alt', langName)
    langTitle.textContent = langName;
  });
}





document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('wishlistModal');
  const closeButton = document.querySelector('.custom-modal-close');
  const saveButton = document.getElementById('saveWishlistButton');
  const createWishlistButton = document.getElementById('createWishlistButton');
  const wishlistContainer = document.getElementById('wishlistContainer');
  let wishlistData = {};

  const getInitials = (name) => {
    const words = name.split(' ');
    const firstLetter = words[0].charAt(0).toUpperCase();
    const secondLetter = words.length > 1 ? words[1].charAt(0).toUpperCase() : '';
    return firstLetter + secondLetter;
  };

  const updateSaveButtonState = () => {
    const selectedWishlists = document.querySelectorAll('.wishlist-checkbox:checked');
    if (selectedWishlists.length === 0) {
      saveButton.classList.add('disabled');
      saveButton.disabled = true;
    } else {
      saveButton.classList.remove('disabled');
      saveButton.disabled = false;
    }
  };

  const addToWishlistClickHandler = event => {
    event.preventDefault();
    //const productItem = event.target.closet('.product-item')
    //console.log(productItem)
    const initiator = event.target.closest('.product-item');
    console.log(initiator)
    // Set the product title and image dynamically
    const productTitle = initiator.querySelector('.wishlist-icon').dataset.productTitle;
    const productImage = initiator.querySelector('.wishlist-icon').dataset.productImage;
    document.getElementById('productTitle').innerText = productTitle;
    document.getElementById('productImage').src = productImage;

    // Capture the selected quantity from the product card or product page
    var quantityInput = 1;
    if (initiator.querySelector('.quantity__input')) {
      quantityInput = initiator.querySelector('.quantity__input').value;
    }
    const selectedQuantity = quantityInput;

    fetch('/cart?view=wishlist')
      .then(res => res.json())
      .then(wishlist => {
        wishlistData = wishlist;
        const wishlistNames = Object.keys(wishlist);

        // Populate the wishlist options with checkboxes
        wishlistContainer.innerHTML = ''; // Clear previous options
        if (wishlistNames.length === 0) {
          // If no existing wishlists, show the input field for a new wishlist
          addNewWishlistInput();
        } else {
          wishlistNames.forEach(name => {
            const wishlistItem = document.createElement('div');
            wishlistItem.className = 'custom-wishlist-item';
            const initials = getInitials(name);
            const productCount = wishlist[name].length;
            wishlistItem.innerHTML = `
              <div class="custom-wishlist-avatar">
                ${initials}
              </div>
              <div class="custom-wishlist-input">${name} (${productCount})</div>
              <div class="custom-wishlist-icon">
                <input type="checkbox" name="wishlist" class="wishlist-checkbox" value="${name}">
              </div>
            `;
            wishlistContainer.appendChild(wishlistItem);
          });
        }

        // Show the modal
        modal.style.display = 'block';
        updateSaveButtonState();
      });

    saveButton.onclick = () => {
      const selectedWishlists = document.querySelectorAll('.wishlist-checkbox:checked');
      const objToAddToWishlist = {
        quantity: selectedQuantity, // Use the captured quantity here
        productId: initiator.querySelector('.wishlist-icon').dataset.productId,
        dateAdded: new Date().toUTCString()
      };

      selectedWishlists.forEach(checkbox => {
        const wishlistNameInput = checkbox.closest('.custom-wishlist-item').querySelector('input[type="text"]');
        const wishlistNameToUse = wishlistNameInput ? wishlistNameInput.value : checkbox.value;

        if (wishlistNameToUse) {
          if (Object.keys(wishlistData).includes(wishlistNameToUse)) {
            wishlistData[wishlistNameToUse].push(objToAddToWishlist);
          } else {
            wishlistData[wishlistNameToUse] = [objToAddToWishlist];
          }
        }
      });

      fetch("/a/custmeta", {
        method: "POST",
        body: new URLSearchParams({
          'customer[id]': window.customerID,
          'metafield[global.wishlist_json]': JSON.stringify(wishlistData)
        }).toString(),
        headers: { "Content-type": "application/x-www-form-urlencoded" }
      })
        .then(response => response.json())
        .then(res => {
          if (res.status === 'ERROR') {
            // TODO: show an error
            return;
          }
          // TODO: show some kind of success
        })
        .catch(err => {
          // TODO: handle error
        });

      // Hide the modal
      modal.style.display = 'none';
    };
  };

  const addNewWishlistInput = () => {
    const wishlistItem = document.createElement('div');
    wishlistItem.className = 'custom-wishlist-item';
    wishlistItem.innerHTML = `
      <div class="custom-wishlist-avatar"></div>
      <div class="custom-wishlist-input">
        <input type="text" class="custom-form-control" placeholder="Enter Wishlist Name">
      </div>
      <div class="custom-wishlist-icon">
        <input type="checkbox" name="wishlist" class="wishlist-checkbox" checked>
      </div>
    `;
    wishlistContainer.appendChild(wishlistItem);

    // Add the new wishlist to wishlistData object with a temporary name
    const tempWishlistName = `Temp Wishlist ${Date.now()}`;
    // wishlistData[tempWishlistName] = [];
    updateSaveButtonState();
  };

  createWishlistButton.onclick = () => {
    addNewWishlistInput();
  };

  const attachWishlistListeners = () => {
    document.querySelectorAll('.collection-search__wishlist, .pdp-header__wishlist, .js-add-to-wishlist').forEach(button => {
      button.addEventListener('click', addToWishlistClickHandler);
    });
  };

  attachWishlistListeners(); // Attach initial listeners

  wishlistContainer.addEventListener('change', updateSaveButtonState);

  closeButton.onclick = () => {
    modal.style.display = 'none';
  };

  window.onclick = event => {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  };

  // Attach listeners for dynamically loaded content
  const observer = new MutationObserver(() => {
    attachWishlistListeners();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
